import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import {
  fieldsToGqlString, mergeByIdNewAtTop,
} from '../../../util/shared/vue-global';

const { backend, backendRest } = clients.direct;
export const urlEncodeObject = (obj) => new URLSearchParams(obj).toString();

const taxFields = {
  _id: '',
  profileName: '',
  taxYearTo: '',
  taxYearFrom: '',
  taxType: '',
  anyTaxDue: '',
  noTax: '',
  anyTaxStillDue: '',
  noPayments: '',
  halfOrPartialPayment: '',
  wkstID: '',
  paidInFull: '',
  includeInfo: {
    anythingWithMtgCode: '',
    fromMtgCode: '',
    toMtgCode: '',
    onlyTheseStatusCodes: '',
    anythingWithCertificateNumber: '',
    fromCertificateNumber: '',
    incTaxAmountGreaterThan: '',
    toCertificateNumber: '',
    taxDistricts: '',
    anythingWithEmailAddress: '',
    // assessorChanges: '',
    fromDate: '',
    // advertised: '',
    toDate: '',
  },
  excludeInfo: {
    anythingWithMtgCode: '',
    onlyTheseMtgCodes: '',
    fromMtgCode: '',
    toMtgCode: '',
    onlyTheseStatusCodes: '',
    anythingWithCertificateNumber: '',
    fromCertificateNumber: '',
    toCertificateNumber: '',
    anythingWithEmailAddress: '',
    fromDate: '',
    // advertised: '',
  },
};
const defaultFields = {
  importedData: '',
  totalRecords: '',
  importingStatus: '',
  isThereAnError: '',
};

const browseListFields = {
  result: {
    _id: '',
    profileName: '',
    wkstID: '',
    name: '',
    cratedAt: '',
    updatedAt: '',
    totalDue: '',
    ownerName: '',
    taxId: '',
    taxYear: '',
    taxType: '',
    propertyOrParcelId: '',
    schoolDistrict: '',
    mtgCode: '',
    emailAddess: '',
    taxInquiryTransaction: {
      _id: '',
      baseId: '',
      taxYear: '',
      taxId: '',
      taxType: '',
      propertyOrParcelId: '',
      name1: '',
      name2: '',
      schoolDistrict: '',
      mtgCode: '',
      emailAddess: '',
    },
  },
  totalCount: '',
  totalParcelCount: '',
};
const profileListFields = {
  wkstID: '',
  name: '',
};

export const trWorkFile = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
    isDialog: false,
    totalTRRecordsCount: 0,
    totalTRParcelCount: 0,
    statementJobs: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    settotalTRRecordsCount(state, items) {
      state.totalTRRecordsCount = items;
    },
    settotalTRParcelCount(state, items) {
      state.totalTRParcelCount = items;
    },
    addStatementJob(state, job) {
      state.statementJobs = [...state.statementJobs, job];
    },
    updateStatementJob(state, { localId, updates }) {
      state.statementJobs = state.statementJobs.map((j) => (j.localId === localId ? { ...j, ...updates } : j));
    },
    removeStatementJob(state, localId) {
      state.statementJobs = state.statementJobs.filter((j) => j.localId !== localId);
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTRWorkFileRecords({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxRollWorkFileTrans($criteria: trWorkFileCriteriaType) {
              taxRollWorkFileTrans(criteria: $criteria) {
                ${fieldsToGqlString(taxFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxRollWorkFileTrans } = results.data;
          commit('base/crud/setItems', [baseCrudKey, taxRollWorkFileTrans], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting transactions.', { root: true });
      }
    },
    async loadTRWorkFileBrowseList({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query browseTaxRollWorkFileTrans($criteria: browseTrWorkFileCriteriaType) {
              browseTaxRollWorkFileTrans(criteria: $criteria) {
                ${fieldsToGqlString(browseListFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { result } = results.data.browseTaxRollWorkFileTrans;
          const { totalCount, totalParcelCount } = results.data.browseTaxRollWorkFileTrans;
          commit('settotalTRRecordsCount', totalCount);
          commit('settotalTRParcelCount', totalParcelCount);
          const taxRollFileData = [];
          for (let i = 0; i < result.length; i += 1) {
            const row = result[i];
            const sinObj = row.taxInquiryTransaction || {};
            if (sinObj) sinObj.taxInquiryTransaction = (row.taxInquiryTransaction || {})._id || '';
            else sinObj.taxInquiryTransaction = '';
            sinObj._id = row._id;
            sinObj.totalDue = row.totalDue;
            sinObj.ownerName = row.ownerName;
            // Fall back to root-level fields when taxInquiryTransaction is missing
            sinObj.taxId = sinObj.taxId || row.taxId;
            sinObj.taxYear = sinObj.taxYear || row.taxYear;
            sinObj.taxType = sinObj.taxType || row.taxType;
            sinObj.propertyOrParcelId = sinObj.propertyOrParcelId || row.propertyOrParcelId;
            sinObj.schoolDistrict = sinObj.schoolDistrict || row.schoolDistrict;
            sinObj.mtgCode = sinObj.mtgCode || row.mtgCode;
            sinObj.emailAddess = sinObj.emailAddess || row.emailAddess;
            taxRollFileData.push(sinObj);
          }
          commit('base/crud/setItems', [baseCrudKey, taxRollFileData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        commit('base/crud/setItems', [baseCrudKey, []], { root: true });
        dispatch('flashError', 'There was a problem getting transactions.', { root: true });
      }
    },
    async jumpToTrWorkFileRecord({ commit, dispatch }, {
      criteria, jumpColumn, jumpValue, jumpDirection,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query jumpToTrWorkFileRecord($criteria: browseTrWorkFileCriteriaType, $jumpColumn: String!, $jumpValue: String!, $jumpDirection: String) {
              jumpToTrWorkFileRecord(criteria: $criteria, jumpColumn: $jumpColumn, jumpValue: $jumpValue, jumpDirection: $jumpDirection) {
                position,
              }
            }
          `,
          variables: {
            criteria, jumpColumn, jumpValue, jumpDirection,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return results.data ? results.data.jumpToTrWorkFileRecord : null;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem finding that record.', { root: true });
        return null;
      }
    },
    async loadTRselectedRecord({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxRollWorkFileTrans($criteria: trWorkFileCriteriaType) {
              taxRollWorkFileTrans(criteria: $criteria) {
                ${fieldsToGqlString(taxFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxRollWorkFileTrans } = results.data;
          if (taxRollWorkFileTrans.length > 0) {
            return taxRollWorkFileTrans;
          }
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting transactions.', { root: true });
      }
      return '';
    },
    async upsertTaxRollFileTransaction({ dispatch, commit, rootGetters }, {
      baseCrudKey, item,
    }) {
      let results;
      let taxtypeCustom;
      if (item.taxType !== null && item.taxType.length > 0) {
        taxtypeCustom = item.taxType;
      } else {
        taxtypeCustom = null;
      }
      try {
        const customObject = {
          profileName: item.profileName !== undefined ? item.profileName : null,
          taxYearFrom: item.taxYearFrom,
          taxYearTo: item.taxYearTo,
          taxType: taxtypeCustom,
          anyTaxDue: item.anyTaxDue || false,
          noTax: item.noTax || false,
          anyTaxStillDue: item.anyTaxStillDue || false,
          noPayments: item.noPayments || false,
          halfOrPartialPayment: item.halfOrPartialPayment || false,
          paidInFull: item.paidInFull || false,
          wkstID: item.wkstID,
          includeInfo: {
            anythingWithMtgCode: item.incAnythingWithMtgCode || false,
            fromMtgCode: item.incFromMtgCode || null,
            toMtgCode: item.incToMtgCode || null,
            onlyTheseStatusCodes: item.incOnlyTheseStatusCodes || null,
            anythingWithCertificateNumber: item.incAnythingWithCertificateNumber || false,
            fromCertificateNumber: item.incFromCertificateNumber || null,
            incTaxAmountGreaterThan: item.incTaxAmountGreaterThan || null,
            toCertificateNumber: item.incToCertificateNumber || null,
            taxDistricts: item.incTaxDistricts || null,
            anythingWithEmailAddress: item.incAnythingWithEmailAddress || false,
            // assessorChanges: item.incAssessorChanges || false,
            fromDate: item.incFromDate || null,
            // advertised: item.incAdvertised || false,
            toDate: item.incToDate || null,
            // advertisedFromeDate: item.incAdvertisedFromdDate || null,
          },
          excludeInfo: {
            anythingWithMtgCode: item.excAnythingWithMtgCode || false,
            onlyTheseMtgCodes: item.excOnlyTheseMtgCodes || null,
            fromMtgCode: item.excFromMtgCode || null,
            toMtgCode: item.excToMtgCode || null,
            onlyTheseStatusCodes: item.excOnlyTheseStatusCodes || null,
            anythingWithCertificateNumber: item.excAnythingWithCertificateNumber || false,
            fromCertificateNumber: item.excFromCertificateNumber || null,
            toCertificateNumber: item.excToCertificateNumber || null,
            // advertised: item.excAdvertised || false,
            anythingWithEmailAddress: item.excAnythingWithEmailAddress || false,
            fromDate: item.excFromDate || null,
          },
        };
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxRollWorkFile ($customObject: trWorkFileMutationFields)  {
            upsertTaxRollWorkFile(upsert: $customObject) {
              ${fieldsToGqlString(taxFields)},
            }
          }`,
          variables: {
            customObject,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxRollTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newItem = results.data ? (results.data.upsertTaxRollWorkFile
          || {}) : {};
        const newList = mergeByIdNewAtTop(taxRollTransStateData || {}, newItem);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        dispatch('flashSuccess', 'Profile has been Saved Successfully', { root: true });
        return newItem;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async upsertTRWorkFileBrowseList({ dispatch, commit, rootGetters }, {
      item, baseCrudKey,
    }) {
      if (item.taxType && item.taxType.length === 0) {
        // eslint-disable-next-line no-param-reassign
        item.taxType = null;
      }
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertBrowseTaxRollWorkFile ($item: browseTrWorkFileMutationFields)  {
            upsertBrowseTaxRollWorkFile(upsert: $item) {
              result
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxRollBrowseTransStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newItem = results.data ? (results.data.upsertBrowseTaxRollWorkFile
          || {}) : {};
        const newList = mergeByIdNewAtTop(taxRollBrowseTransStateData || {}, newItem);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        return newItem;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting', { root: true });
      }
      return {};
    },
    async loadProfileList({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query profileList($criteria: browseTrProfileInputType) {
              profileList(criteria: $criteria) {
                ${fieldsToGqlString(profileListFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { profileList } = results.data;
          commit('base/crud/setItems', [baseCrudKey, profileList], { root: true });
          return profileList;
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting transactions.', { root: true });
      }
      return {};
    },
    async deleteTrWorkFileProfile({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`
            mutation deleteTaxRollWorkFileProfile($id: ID!) {
              deleteTaxRollWorkFileProfile(id: $id) {
                _id
              }
            }
          `,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteTaxRollWorkFileProfile._id;
        const trWorkFileProfiles = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = trWorkFileProfiles.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        dispatch('flashSuccess', 'Profile has been deleted', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the Profile!', { root: true });
      }
    },
    async upsertTRWorkFileNewRecord({ dispatch, commit, rootGetters }, { itemData, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`
            mutation upsertBrowseFileRecord($itemData: [browseTrWorkFileMutationFields]) {
              upsertBrowseFileRecord(upserts: $itemData) {
                _id,
                result,
                wkstID,
                taxYear,
                profileName,
                name,
                mtgCode,
                ownerName,
                taxId,
                schoolDistrict,
                name1,
                propertyOrParcelId,
                taxType,
              }
            }
          `,
          variables: {
            itemData,
          },
        });
        clients.handleGQLErrors(results, commit);

        const newItem = results.data ? (results.data.upsertBrowseFileRecord || {}) : null;

        // Check the result before adding the new item to the list
        if (newItem && newItem.result !== 'record already exists' && newItem.result !== 'no record found in taxInquiryTransaction' && newItem.result !== 'please select name to add rcord') {
          const taxRollBrowseTransStateData = rootGetters['base/crud/items'](baseCrudKey);
          const newList = mergeByIdNewAtTop(taxRollBrowseTransStateData || {}, newItem);
          commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
          if (newItem.result === 'record added') dispatch('flashSuccess', 'Record added successfully', { root: true });
        } else if (newItem.result === 'please select name to add rcord') dispatch('flashWarn', 'please select File Name to proceed to add record', { root: true });
        else if (newItem.result === 'record already exists') dispatch('flashInfo', 'The record already exits in browse TR Work File', { root: true });
        else if (newItem.result === 'no record found in taxInquiryTransaction') dispatch('flashWarn', 'No record found in taxInquiryTransaction', { root: true });
        return newItem;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting', { root: true });
      }
      return {};
    },

    async deleteBrowseTrFileRecord({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTrBrowseRecord($id: ID!)  {
            deleteTrBrowseRecord(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteTrBrowseRecord._id;
        const receivedStateData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = receivedStateData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Recieved Of list', { root: true });
      }
    },
    async updateTrBrowseListActions({ dispatch, commit }, { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation updateListActionsFromTrFile($itemToSent: [taxTransactionInputType!])  {
            updateListActionsFromTrFile(upserts: $itemToSent) {
              modifiedCount,
            }
          }`,
          variables: {
            itemToSent,
          },
        });
        dispatch('flashSuccess', ` ${itemToSent.flag} has been applied Successfully`, { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Mortgage Codes', { root: true });
      }
    },
    async upsertCommentsBulk({ dispatch, commit }, { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxCommentsFromTrFile($itemToSent: taxCommentMutationInputType)  {
            upsertTaxCommentsFromTrFile(upserts: $itemToSent) {
              insertedCount,
            }
          }`,
          variables: {
            itemToSent,
          },
        });
        dispatch('flashSuccess', 'comment has been aadded Successfully', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the tax comments', { root: true });
      }
    },
    async assignCertNumber({ dispatch, commit }, { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation assignCertNumberFromTr($itemToSent: browseTrWorkFileMutationFields)  {
            assignCertNumberFromTr(upserts: $itemToSent) {
              insertedCount,
            }
          }`,
          variables: {
            itemToSent,
          },
        });
        dispatch('flashSuccess', 'cert has been aadded Successfully', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the cert number', { root: true });
      }
    },
    async removePaidRecordsBrowseTrFile({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletePaidRecordsFromTr($itemToSent: browseTrWorkFileMutationFields!)  {
            deletePaidRecordsFromTr(upserts: $itemToSent) {
                  deletedCount,
                  pendingPaymentCount,
                }
              }`,
          variables: {
            itemToSent,
          },
        });
        const { deletedCount, pendingPaymentCount } = results.data.deletePaidRecordsFromTr;
        let message = `${deletedCount} paid record${deletedCount === 1 ? '' : 's'} removed.`;
        if (pendingPaymentCount) {
          message += ` ${pendingPaymentCount} of them had a pending payment status code (416/419).`;
        }
        dispatch('flashSuccess', message, { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the paid records', { root: true });
      }
    },
    async removeOverpaidRecordsBrowseTrFile({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation removeOverpaidRecordsBrowseTrFile($itemToSent: browseTrWorkFileMutationFields!)  {
            removeOverpaidRecordsBrowseTrFile(upserts: $itemToSent) {
                  deletedCount,
                }
              }`,
          variables: {
            itemToSent,
          },
        });
        dispatch('flashSuccess', ' Overpaid records has been removed Successfully', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the overpaid records', { root: true });
      }
    },
    // What the fee add would do, asked before doing it, so the caller can warn about a re-run.
    // Returns null when the preview itself fails - the caller treats that as "cannot tell" and
    // carries on rather than blocking the add on a read.
    async previewAddFeeRecordsInBulk({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query addFeesFromTrPreview($itemToSent: taxFeesInputType!)  {
            addFeesFromTrPreview(upserts: $itemToSent) {
                  requestedCount,
                  alreadyCarryingFeeCount,
                }
              }`,
          variables: {
            itemToSent,
          },
          fetchPolicy: 'no-cache',
        });
        return results.data.addFeesFromTrPreview;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        return null;
      }
    },
    async addFeeRecordsInBulk({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation addFeesFromTr($itemToSent: taxFeesInputType!)  {
            addFeesFromTr(upserts: $itemToSent) {
                  upsertedCount,
                  requestedCount,
                  alreadyCarryingFeeCount,
                }
              }`,
          variables: {
            itemToSent,
          },
        });
        // Report the count rather than a bare "Successfully". A run that wrote nothing used to
        // flash success all the same, which is what leaves a clerk deciding for themselves whether
        // it worked - and re-running when they guess wrong.
        const { upsertedCount } = results.data.addFeesFromTr;
        dispatch('flashSuccess', `Fee added to ${upsertedCount} record(s)`, { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        // Surface the server's own message: the fee add now refuses to apply a partial batch and
        // says so, and "there was a problem" would throw that away.
        dispatch('flashError', (e && e.message) || 'There was a problem upserting fee records', { root: true });
      }
    },
    async deleteFeeRecordsInBulk({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation removeFeesFromTr($itemToSent: taxFeesInputType!)  {
            removeFeesFromTr(upserts: $itemToSent) {
                  deletedCount,
                }
              }`,
          variables: {
            itemToSent,
          },
        });
        dispatch('flashSuccess', 'fee has been deleted successfully', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting fee records', { root: true });
      }
    },
    async addDelinquentRecordsInBulk({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation addDelinquentRecords($itemToSent: browseTrWorkFileMutationFields!)  {
            addDelinquentRecords(upserts: $itemToSent) {
                  upsertedCount,
                }
              }`,
          variables: {
            itemToSent,
          },
        });
        dispatch('flashSuccess', 'DelinquentRecords has been added Successfully', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem adding delinquent records', { root: true });
      }
    },
    async createJuneResaleRecords({ commit, dispatch },
      { itemToSent }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation createJuneResaleRecords($itemToSent: createJuneResaleInputType!)  {
            createJuneResaleRecords(upsert: $itemToSent) {
                  statusCode,
                }
              }`,
          variables: {
            itemToSent,
          },
        });
        const { createJuneResaleRecords } = results.data;
        if (createJuneResaleRecords.statusCode === 200) dispatch('flashSuccess', 'June Resale records created Successfully', { root: true });
        return createJuneResaleRecords;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem adding june resale records', { root: true });
      }
      return {};
    },
    async loadBrowseTrBulkWriteStatus({ dispatch }) {
      try {
        const { data } = await backend.query({
          query: gql`query importStatusTR {
                importStatusTR {
                  ${fieldsToGqlString(defaultFields)},
                } 
              }`,
          fetchPolicy: 'no-cache',
        });
        if (data) {
          return data.importStatusTR;
        }
        dispatch('flashWarn', 'There was a problem while Writing data.', { root: true });
      } catch (error) {
        dispatch('logException', error, { root: true });
        dispatch('flashError', 'There was a problem getting data.', { root: true });
        return 0;
      }
      return null;
    },
    async sendMailTR({ dispatch, commit }, { item }) {
      let results;
      try {
        const url = `taxInquiry/pick-list/printlistEmail?${urlEncodeObject(item)}`;

        const response = await backendRest.get(url);
        if (response.status === 200) {
          dispatch('flashSuccess', `${response.data.message}`, { root: true });
        } else {
          dispatch('flashError', `${response.data.error}`, { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Overpayments & Refunds.', { root: true });
      }
      return null;
    },
    // --- Bulk "Email Statements" -------------------------------------------------------
    // These replace a browser-side loop that sent one awaited request per record from the
    // tab. It died with the tab, only ever saw the grid's CURRENT PAGE, and counted HTTP 200s
    // from an endpoint that answered before it had tried to send - so its "N sent
    // successfully" meant nothing. The run now happens server-side against the whole filtered
    // list, and every number below is read back from the server's own per-record log.

    // What a run would do, for the confirm dialog - including the records it would skip.
    async previewBulkEmailStatements({ dispatch }, { criteria, excludeAlreadySent = true }) {
      try {
        const params = urlEncodeObject({
          filters: JSON.stringify(criteria),
          excludeAlreadySent: excludeAlreadySent ? 'true' : 'false',
        });
        const { data } = await backendRest.get(`/taxInquiry/pick-list/emailStatement/preview?${params}`);
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
        const msg = (e.response && e.response.data && e.response.data.error)
          || 'Could not work out how many records would be emailed.';
        dispatch('flashError', msg, { root: true });
        return null;
      }
    },

    // Kick the run off and return its id. Nothing here holds a token for the run: the server
    // authorizes once, at kickoff, and mints its own credential per send afterwards.
    async startBulkEmailStatementsRun({ dispatch }, {
      criteria, emailSettings, penaltyDate, wkstNumber, label, excludeAlreadySent = true,
    }) {
      try {
        const params = urlEncodeObject({
          filters: JSON.stringify(criteria),
          subject: emailSettings.subjectLine || '',
          subjectBody: emailSettings.subjectBody || '',
          bccEmailAddress: emailSettings.bccEmailAddress || '',
          penaltyDate: penaltyDate || '',
          wkst: wkstNumber != null ? Number(wkstNumber) : '',
          label: label || '',
          excludeAlreadySent: excludeAlreadySent ? 'true' : 'false',
        });
        const { data } = await backendRest.get(`/taxInquiry/pick-list/emailStatement/async?${params}`);
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
        const msg = (e.response && e.response.data && e.response.data.error)
          || 'Could not start the email run.';
        dispatch('flashError', msg, { root: true });
        return null;
      }
    },

    async loadBulkEmailRuns({ dispatch }) {
      try {
        const { data } = await backendRest.get('/taxInquiry/pick-list/emailStatement/runs');
        return (data && data.runs) || [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        return [];
      }
    },

    async cancelBulkEmailRun({ dispatch }, { runId }) {
      try {
        const { data } = await backendRest.get(`/taxInquiry/pick-list/emailStatement/run/${runId}/cancel`);
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'Could not cancel that run.', { root: true });
        return null;
      }
    },

    // Re-sends exactly the rows that failed, as a new run. Anyone already sent keeps their
    // 'sent' row and is not emailed again.
    async retryFailedBulkEmails({ dispatch }, { runId }) {
      try {
        const { data } = await backendRest.get(`/taxInquiry/pick-list/emailStatement/run/${runId}/retry-failed`);
        dispatch('flashSuccess', `Retrying ${data.total} failed record(s).`, { root: true });
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
        const msg = (e.response && e.response.data && e.response.data.error)
          || 'Could not retry the failed records.';
        dispatch('flashError', msg, { root: true });
        return null;
      }
    },

    async loadBulkEmailRunLog({ dispatch }, {
      runId, status, skip = 0, limit = 100,
    }) {
      try {
        const params = urlEncodeObject({
          ...(status ? { status } : {}), skip, limit,
        });
        const { data } = await backendRest.get(`/taxInquiry/pick-list/emailStatement/run/${runId}/log?${params}`);
        return data;
      } catch (e) {
        dispatch('logException', e, { root: true });
        dispatch('flashError', 'Could not load the run log.', { root: true });
        return null;
      }
    },
    async loadPickListDataInTr({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query pickListRecordsInTr($criteria: browseTrWorkFileCriteriaType) {
              pickListRecordsInTr(criteria: $criteria) {
                ${fieldsToGqlString(browseListFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting transactions.', { root: true });
      }
      return [];
    },
    async deleteRecordsFromTrBasedOnIds({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteRecordsFromTrBasedOnIds ($item:deleteRecordsFromTrBasedOnIdsInputType)  {
            deleteRecordsFromTrBasedOnIds(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { deleteRecordsFromTrBasedOnIds } = results.data;
        if (deleteRecordsFromTrBasedOnIds.statusCodes === 200) {
          dispatch('flashSuccess', 'The selected records were deleted from TR Work File', { root: true });
        } else dispatch('flashError', 'There was a problem in deleting the records from TR Work File', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the records from TR Work File!', { root: true });
      }
    },
    async deleteRecordsFromTrBasedOnFileName({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteRecordsFromTrBasedOnFileName ($item:deleteRecordsFromTrBasedOnFileNameInputType)  {
            deleteRecordsFromTrBasedOnFileName(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { deleteRecordsFromTrBasedOnFileName } = results.data;
        if (deleteRecordsFromTrBasedOnFileName.statusCodes === 200) {
          dispatch('flashSuccess', 'The selected records were deleted from TR Work File', { root: true });
        } else dispatch('flashError', 'There was a problem in deleting the records from TR Work File', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the records from TR Work File!', { root: true });
      }
    },
  },
};

export default trWorkFile;
